import { render, staticRenderFns } from "./flowServiceForm.vue?vue&type=template&id=963f3ad4&"
import script from "./flowServiceForm.vue?vue&type=script&lang=js&"
export * from "./flowServiceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports